// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","loader_container":"App_loader_container__VgN3C","loader_image":"App_loader_image__azP7m"};